export const routeToCategoryMap = {
  // Inbox
  inbox_view: 'Inbox',
  inbox_view_conversation: 'Inbox',
  archives_view: 'Reports',
  archives_view_conversation: 'Reports',
  // Conversation
  home: 'Conversation',
  inbox_conversation: 'Conversation',
  conversation_mentions: 'Conversation',
  conversation_unattended: 'Conversation',
  conversation_vip: 'Conversation',
  conversation_wlab_ai_agent_all: 'Conversation',
  conversation_wlab_ai_agent_resolved: 'Conversation',
  conversation_wlab_ai_agent_handoff: 'Conversation',
  conversation_wlab_ai_agent_pending: 'Conversation',
  conversation_through_vip: 'Conversation',
  conversation_through_wlab_ai_agent_all: 'Conversation',
  conversation_through_wlab_ai_agent_resolved: 'Conversation',
  conversation_through_wlab_ai_agent_handoff: 'Conversation',
  conversation_through_wlab_ai_agent_pending: 'Conversation',
  issue_conversations: 'Conversation',
  team_conversations: 'Conversation',
  inbox_dashboard: 'Conversation',
  label_conversations: 'Conversation',
  folder_conversations: 'Conversation',
  conversations_through_team: 'Conversation',
  conversations_through_label: 'Conversation',
  conversations_through_folders: 'Conversation',
  conversations_through_issue: 'Conversation',
  conversation_through_inbox: 'Conversation',
  qa_monitor_home: 'QADashboard',
  qa_monitor_conversation: 'QADashboard',
  qa_monitor_inbox: 'QADashboard',
  qa_monitor_conversation_through_inbox: 'QADashboard',
  // AiLab
  ailab_assistants_index: 'AiLab',
  ailab_documents_index: 'AiLab',
  ailab_responses_index: 'AiLab',
  ailab_product_info: 'AiLab',
  ailab_assistant_v2: 'AiLab',
  ailab_ai_closer_index: 'AiLab',
  ailab_ai_gamer_index: 'AiLab',
  ailab_ai_closer_assistant_v2: 'AiLab',
  ailab_ai_gamer_assistant_v2: 'AiLab',
  ailab_brand_training_dashboard: 'AiLab',
  ailab_brand_training_assistant: 'AiLab',
  ailab_brand_training_knowledge: 'AiLab',
  // Contacts
  contacts_dashboard_index: 'Contacts',
  contacts_dashboard_active: 'Contacts',
  contacts_dashboard_vip: 'Contacts',
  contacts_edit: 'Contacts',
  contacts_dashboard_segments_index: 'Contacts',
  contacts_dashboard_labels_index: 'Contacts',
  contacts_edit_segment: 'Contacts',
  contacts_edit_label: 'Contacts',
  // Reports
  account_overview_reports: 'Reports',
  conversation_reports: 'Reports',
  case_closing_types_reports: 'Reports',
  live_chat_forms_export_reports: 'Reports',
  chat_history_export_reports: 'Reports',
  agent_reports_index: 'Reports',
  agent_reports_show: 'Reports',
  label_reports_index: 'Reports',
  inbox_reports_index: 'Reports',
  inbox_reports_show: 'Reports',
  team_reports_index: 'Reports',
  team_reports_show: 'Reports',
  vip_reports_index: 'Reports',
  vip_reports_show: 'Reports',
  vip_agent_reports_index: 'Reports',
  issue_reports_index: 'Reports',
  line_delivery_reports: 'Reports',
  qa_overrides_reports_index: 'Reports',
  cross_brand_reports_index: 'Reports',
  csat_reports: 'Reports',
  sla_reports: 'Reports',
  bot_reports: 'Reports',
  telegram_bot_reports: 'Reports',
  token_usage_reports: 'Reports',
  // Engage
  engage_traffic_index: 'Engage',
  engage_campaigns_index: 'Engage',
  engage_goals_index: 'Engage',
  // Team management
  team_management_agents: 'TeamManagement',
  team_management_chatbots: 'TeamManagement',
  team_management_groups: 'TeamManagement',
  team_management_suspended_agents: 'TeamManagement',
  // QA Dashboard
  qa_dashboard_template_audit: 'QADashboard',
  qa_dashboard_close_type_audit: 'QADashboard',
  qa_dashboard_keyword_search: 'QADashboard',
  // Workforce
  workforce_my_shift: 'Workforce',
  workforce_schedules: 'Workforce',
  workforce_assignment: 'Workforce',
  workforce_attendance: 'Workforce',
  workforce_live: 'Workforce',
  // Campaigns
  campaigns_livechat_index: 'Campaigns',
  campaigns_sms_index: 'Campaigns',
  campaigns_telegram_index: 'Campaigns',
  campaigns_telegram_new: 'Campaigns',
  campaigns_telegram_edit: 'Campaigns',
  campaigns_telegram_report: 'Campaigns',
  campaigns_whatsapp_index: 'Campaigns',
  campaigns_line_index: 'Campaigns',
  campaigns_line_new: 'Campaigns',
  campaigns_line_edit: 'Campaigns',
  campaigns_line_report: 'Campaigns',
  // Voice (AI Voice) — list + detail for both calls and campaigns.
  // Without these entries detectCategoryFromRoute returns null on
  // refresh, and the focused subsidebar reverts to the default full
  // category list — inconsistent UX vs. every other rail category.
  voice_overview: 'Voice',
  voice_calls_list: 'Voice',
  voice_call_detail: 'Voice',
  voice_campaigns_list: 'Voice',
  voice_campaign_detail: 'Voice',
  voice_campaign_new: 'Voice',
  voice_costs_dashboard: 'Voice',
  voice_search: 'Voice',
  voice_playground: 'Voice',
  // Portals
  portals_index: 'Portals',
  portals_articles_index: 'Portals',
  portals_articles_new: 'Portals',
  portals_articles_edit: 'Portals',
  portals_categories_index: 'Portals',
  portals_categories_articles_index: 'Portals',
  portals_categories_articles_edit: 'Portals',
  portals_locales_index: 'Portals',
  portals_settings_index: 'Portals',
  // Settings
  profile_settings: 'Settings',
  profile_settings_index: 'Settings',
  profile_settings_mfa: 'Settings',
  general_settings_index: 'Settings',
  agent_list: 'Settings',
  settings_teams_list: 'Settings',
  settings_issues_list: 'Settings',
  assignment_policy_index: 'Settings',
  settings_inbox_list: 'Settings',
  settings_inbox_show: 'Settings',
  settings_inbox_new: 'Settings',
  settings_inbox_finish: 'Settings',
  settings_inboxes_page_channel: 'Settings',
  settings_inboxes_add_agents: 'Settings',
  labels_list: 'Settings',
  attributes_list: 'Settings',
  automation_list: 'Settings',
  automation_flows_list: 'Settings',
  settings_telegram_bot_structure: 'Settings',
  settings_telegram_audience: 'Settings',
  settings_telegram_statistics: 'Settings',
  settings_telegram_autoposting: 'Settings',
  settings_telegram_channels_groups: 'Settings',
  settings_telegram_bot_settings: 'Settings',
  agent_bots: 'Settings',
  macros_wrapper: 'Settings',
  canned_list: 'Settings',
  flex_templates_list: 'Settings',
  settings_applications: 'Settings',
  settings_applications_integration: 'Settings',
  settings_applications_webhooks: 'Settings',
  settings_applications_dashboard_apps: 'Settings',
  auditlogs_list: 'Settings',
  custom_roles_list: 'Settings',
  sla_list: 'Settings',
  security_settings_index: 'Settings',
  line_stickers: 'Settings',
  vip_settings_index: 'Settings',
  billing_settings_index: 'Settings',
};

const sectionToCategoryMap = {
  dashboard: 'Conversation',
  inbox: 'Inbox',
  'qa-monitor': 'QADashboard',
  'qa-dashboard': 'QADashboard',
  contacts: 'Contacts',
  reports: 'Reports',
  archives: 'Reports',
  campaigns: 'Campaigns',
  portals: 'Portals',
  engage: 'Engage',
  workforce: 'Workforce',
  ailab: 'AiLab',
  settings: 'Settings',
  profile: 'Settings',
  'team-management': 'TeamManagement',
  'wlab-ai-agent': 'Conversation',
  mentions: 'Conversation',
  participating: 'Conversation',
};

export const detectCategoryFromRoute = (routeLike, fallback = '') => {
  const routeName = String(routeLike?.name || '');
  if (routeName && routeToCategoryMap[routeName]) {
    return routeToCategoryMap[routeName];
  }

  const rawPath = String(
    routeLike?.fullPath || routeLike?.path || window.location?.pathname || ''
  );
  const marker = '/app/accounts/';
  const idx = rawPath.indexOf(marker);
  if (idx >= 0) {
    const rest = rawPath.slice(idx + marker.length);
    const parts = rest.split('/').filter(Boolean);
    const section = (parts[1] || '').toLowerCase();
    if (section && sectionToCategoryMap[section]) {
      return sectionToCategoryMap[section];
    }
  }

  return fallback;
};
